// External libraries
import gql from 'graphql-tag';
import { CART_AMOUNTS_FRAGMENT, CART_ITEMS_FRAGMENT } from '@/lib/graphql';

export const CHECKOUT_SESSION_DATA_QUERY = gql`
  query CheckoutSessionDataQuery($token: String!) {
    checkoutSession(token: $token) {
      allowedCardIssuers

      cart {
        ...CartAmounts

        ...CartItems

        billingAddress {
          city
          line1
          line2
          postalCode
          state
        }

        cancelUrl {
          href
        }

        description

        email {
          stringValue
        }

        intent

        noteToBuyer

        payer {
          name {
            familyName
            givenName
          }
        }

        phoneNumber(shouldValidate: true, stripDialingCode: true)

        shippingAddress {
          city
          firstName
          isStoreAddress
          lastName
          line1
          line2
          postalCode
          state
        }
      }

      merchant {
        country
        merchantId
        name
      }
    }
  }

  ${CART_AMOUNTS_FRAGMENT}
  ${CART_ITEMS_FRAGMENT}
`;
